import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, vModelText as _vModelText, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/sns/Twitter.png'
import _imports_1 from '@/assets/sns/Bluesky.png'
import _imports_2 from '@/assets/sns/Google.png'
import _imports_3 from '@/assets/sns/Naver.png'
import _imports_4 from '@/assets/sns/Youtube.png'
import _imports_5 from '@/assets/sns/Instagram.png'
import _imports_6 from '@/assets/board/excel_ico.png'
import _imports_7 from '@/assets/board/info_ico.png'
import _imports_8 from '@/assets/sns/twitter_ico.png'
import _imports_9 from '@/assets/sns/google_ico.png'
import _imports_10 from '@/assets/sns/naver_ico.png'
import _imports_11 from '@/assets/sns/youtube_ico.png'
import _imports_12 from '@/assets/sns/instargram_ico.png'
import _imports_13 from '@/assets/sns/bluesky_ico.png'


const _withScopeId = n => (_pushScopeId("data-v-6c644a8b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layer" }
const _hoisted_2 = { class: "wrap" }
const _hoisted_3 = { class: "content_layer" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { id: "board_layer" }
const _hoisted_6 = { class: "board_condition" }
const _hoisted_7 = { class: "board_condition_con" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bc_main_tit" }, "검색조건", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bc_line" }, null, -1))
const _hoisted_10 = { class: "bc_result" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = ["src"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bc_line" }, null, -1))
const _hoisted_15 = { class: "bc_sns" }
const _hoisted_16 = {
  key: 0,
  src: _imports_0
}
const _hoisted_17 = {
  key: 1,
  src: _imports_1
}
const _hoisted_18 = {
  key: 2,
  src: _imports_2
}
const _hoisted_19 = {
  key: 3,
  src: _imports_3
}
const _hoisted_20 = {
  key: 4,
  src: _imports_4
}
const _hoisted_21 = {
  key: 5,
  src: _imports_5
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bc_line" }, null, -1))
const _hoisted_23 = { class: "bc_nation" }
const _hoisted_24 = { class: "bc_info" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bc_tit" }, "담당자", -1))
const _hoisted_26 = { class: "bc_info_txt" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bc_tit" }, "검색일", -1))
const _hoisted_28 = { class: "bc_info_txt" }
const _hoisted_29 = { class: "board_top" }
const _hoisted_30 = { class: "board_top_btns" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "엑셀다운로드", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_6 }, null, -1))
const _hoisted_33 = [
  _hoisted_31,
  _hoisted_32
]
const _hoisted_34 = { class: "board_top_btns_right" }
const _hoisted_35 = { class: "count" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "20" }, "20", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "50" }, "50", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "70" }, "70", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "100" }, "100", -1))
const _hoisted_40 = [
  _hoisted_36,
  _hoisted_37,
  _hoisted_38,
  _hoisted_39
]
const _hoisted_41 = { class: "change_list_btns" }
const _hoisted_42 = { class: "board_cate_btns" }
const _hoisted_43 = { class: "chk" }
const _hoisted_44 = ["onUpdate:modelValue"]
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_46 = {
  key: 0,
  class: "info_ico"
}
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_7 }, null, -1))
const _hoisted_48 = [
  _hoisted_47
]
const _hoisted_49 = ["onClick"]
const _hoisted_50 = { class: "gal_thumb_img" }
const _hoisted_51 = ["src"]
const _hoisted_52 = { class: "sns_ico" }
const _hoisted_53 = {
  key: 0,
  src: _imports_8
}
const _hoisted_54 = {
  key: 1,
  src: _imports_9
}
const _hoisted_55 = {
  key: 2,
  src: _imports_10
}
const _hoisted_56 = {
  key: 3,
  src: _imports_11
}
const _hoisted_57 = {
  key: 4,
  src: _imports_12
}
const _hoisted_58 = {
  key: 5,
  src: _imports_13
}
const _hoisted_59 = { class: "gal_thumb_info_div" }
const _hoisted_60 = { class: "gal_info_list" }
const _hoisted_61 = { class: "gal_info_top" }
const _hoisted_62 = { class: "gal_info_tit" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "순번", -1))
const _hoisted_64 = { class: "gal_info_con" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "검색유형", -1))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gal_info_tit" }, "고유번호", -1))
const _hoisted_67 = { class: "gal_info_con" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gal_info_tit" }, "국적", -1))
const _hoisted_69 = { class: "gal_info_con" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gal_info_tit" }, "내용", -1))
const _hoisted_71 = ["innerHTML"]
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gal_info_tit" }, "해시태그", -1))
const _hoisted_73 = ["innerHTML"]
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gal_info_tit" }, "URL", -1))
const _hoisted_75 = { class: "gal_info_con" }
const _hoisted_76 = ["href"]
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gal_info_tit" }, "등록일자", -1))
const _hoisted_78 = { class: "gal_info_con" }
const _hoisted_79 = { class: "gal_info_list" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gal_info_tit" }, "글쓴이(계정)", -1))
const _hoisted_81 = { class: "gal_info_con" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gal_info_tit" }, "메신저 ID", -1))
const _hoisted_83 = { class: "gal_info_con" }
const _hoisted_84 = { class: "sns_id" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gal_info_tit" }, "전화번호", -1))
const _hoisted_86 = { class: "gal_info_con" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gal_info_tit" }, "근거내용", -1))
const _hoisted_88 = { class: "gal_info_con" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gal_info_tit" }, "유형", -1))
const _hoisted_90 = ["onUpdate:modelValue", "onChange"]
const _hoisted_91 = ["value"]
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gal_info_tit" }, "세부유형", -1))
const _hoisted_93 = { class: "gal_info_save_box" }
const _hoisted_94 = ["onUpdate:modelValue", "onChange"]
const _hoisted_95 = ["value"]
const _hoisted_96 = ["onUpdate:modelValue"]
const _hoisted_97 = ["onClick"]
const _hoisted_98 = { class: "gal_btn_div" }
const _hoisted_99 = { key: 0 }
const _hoisted_100 = ["onClick"]
const _hoisted_101 = { class: "gal_top_box" }
const _hoisted_102 = { class: "gal_top_left" }
const _hoisted_103 = { class: "chk" }
const _hoisted_104 = ["onUpdate:modelValue"]
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_106 = { key: 0 }
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_7 }, null, -1))
const _hoisted_108 = [
  _hoisted_107
]
const _hoisted_109 = { class: "gal_thumb" }
const _hoisted_110 = { class: "gal_thumb_img" }
const _hoisted_111 = ["src", "onClick"]
const _hoisted_112 = { class: "sns_ico" }
const _hoisted_113 = {
  key: 0,
  src: _imports_8
}
const _hoisted_114 = {
  key: 1,
  src: _imports_9
}
const _hoisted_115 = {
  key: 2,
  src: _imports_10
}
const _hoisted_116 = {
  key: 3,
  src: _imports_11
}
const _hoisted_117 = {
  key: 4,
  src: _imports_12
}
const _hoisted_118 = {
  key: 5,
  src: _imports_13
}
const _hoisted_119 = { class: "gal_top_txt" }
const _hoisted_120 = ["onClick"]
const _hoisted_121 = { class: "gal_info_top_box" }
const _hoisted_122 = { class: "gal_info_top" }
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "순번", -1))
const _hoisted_124 = { class: "gal_info_top" }
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "국적", -1))
const _hoisted_126 = {
  key: 0,
  class: "gal_btn_div"
}
const _hoisted_127 = { class: "gal_info_div" }
const _hoisted_128 = { class: "gal_info_list" }
const _hoisted_129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gal_info_tit" }, "고유번호", -1))
const _hoisted_130 = { class: "gal_info_con" }
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gal_info_tit" }, "내용", -1))
const _hoisted_132 = ["innerHTML"]
const _hoisted_133 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gal_info_tit" }, "해시태그", -1))
const _hoisted_134 = ["innerHTML"]
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gal_info_tit" }, "URL", -1))
const _hoisted_136 = { class: "gal_info_con" }
const _hoisted_137 = ["href"]
const _hoisted_138 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gal_info_tit" }, "등록일자", -1))
const _hoisted_139 = { class: "gal_info_con" }
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gal_info_tit" }, "글쓴이(계정)", -1))
const _hoisted_141 = { class: "gal_info_con" }
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gal_info_tit" }, "메신저", -1))
const _hoisted_143 = { class: "gal_info_con" }
const _hoisted_144 = { class: "sns_id" }
const _hoisted_145 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gal_info_tit" }, "전화번호", -1))
const _hoisted_146 = { class: "gal_info_con" }
const _hoisted_147 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gal_info_tit" }, "근거내용", -1))
const _hoisted_148 = { class: "gal_info_con" }
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gal_info_tit" }, "유형", -1))
const _hoisted_150 = ["onUpdate:modelValue", "onChange"]
const _hoisted_151 = ["value"]
const _hoisted_152 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gal_info_tit" }, "세부유형", -1))
const _hoisted_153 = { class: "gal_info_save_box" }
const _hoisted_154 = ["onUpdate:modelValue", "onChange"]
const _hoisted_155 = ["value"]
const _hoisted_156 = ["onUpdate:modelValue"]
const _hoisted_157 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Filter = _resolveComponent("Filter")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_NoResult = _resolveComponent("NoResult")!
  const _component_PageBtn = _resolveComponent("PageBtn")!
  const _component_Popup = _resolveComponent("Popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Header),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_Filter, {
                dateRange: false,
                nation: false,
                selectOption: $setup.state.selectOption,
                onSearch: $setup.filterSearch,
                onReset: $setup.resetSearch
              }, null, 8, ["selectOption", "onSearch", "onReset"]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("span", null, _toDisplayString($setup.result.detail.strType), 1),
                  _hoisted_9,
                  _createElementVNode("div", _hoisted_10, [
                    ($setup.result.detail.keyword)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString($setup.result.detail.keyword), 1))
                      : _createCommentVNode("", true),
                    ($setup.result.detail.imgPath && $setup.result.detail.keyword)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, "+"))
                      : _createCommentVNode("", true),
                    ($setup.result.detail.imgPath)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 2,
                          type: "button",
                          class: "bc_thumb",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.showImg($setup.result.detail.imgPath)))
                        }, [
                          _createElementVNode("img", {
                            src: $setup.result.detail.imgPath
                          }, null, 8, _hoisted_13)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _hoisted_14,
                  _createElementVNode("div", _hoisted_15, [
                    ($setup.result.detail.isTwitter)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_16))
                      : _createCommentVNode("", true),
                    ($setup.result.detail.isBluesky)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_17))
                      : _createCommentVNode("", true),
                    ($setup.result.detail.isGoogle)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_18))
                      : _createCommentVNode("", true),
                    ($setup.result.detail.isNaver)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_19))
                      : _createCommentVNode("", true),
                    ($setup.result.detail.isYoutube)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_20))
                      : _createCommentVNode("", true),
                    ($setup.result.detail.isInstagram)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_21))
                      : _createCommentVNode("", true)
                  ]),
                  _hoisted_22,
                  _createElementVNode("p", _hoisted_23, _toDisplayString($setup.result.detail.strNation?.join(", ")), 1)
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _hoisted_25,
                  _createElementVNode("span", _hoisted_26, _toDisplayString($setup.result.detail.meName), 1),
                  _hoisted_27,
                  _createElementVNode("span", _hoisted_28, _toDisplayString($setup.result.detail.createDate ? $setup.formatDate($setup.result.detail.createDate) : ""), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "board_btn",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.checkbtn(0)))
                  }, "전체선택"),
                  _createElementVNode("button", {
                    type: "button",
                    class: "board_btn board_ico_btn",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.excelDownLoad && $setup.excelDownLoad(...args)))
                  }, _hoisted_33)
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, _toDisplayString($setup.numberFormat($setup.state.totalLength)) + "건", 1),
                  _withDirectives(_createElementVNode("select", {
                    name: "",
                    id: "",
                    class: "select",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.state.perPage) = $event))
                  }, _hoisted_40, 512), [
                    [
                      _vModelSelect,
                      $setup.state.perPage,
                      void 0,
                      { number: true }
                    ]
                  ]),
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("button", {
                      type: "button",
                      class: _normalizeClass(["list_btn", $setup.state.layer === 0 ? 'on' : '']),
                      onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.changeLayer(0)))
                    }, null, 2),
                    _createElementVNode("button", {
                      type: "button",
                      class: _normalizeClass(["gal_btn", $setup.state.layer === 1 ? 'on' : '']),
                      onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.changeLayer(1)))
                    }, null, 2)
                  ])
                ])
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["gal_list_wrap", $setup.state.layer === 1 ? 'card' : ''])
              }, [
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.updateCheckLists(2)))
                  }, "모니터링"),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.updateCheckLists(1)))
                  }, "삭제")
                ]),
                (!$setup.state.isLoading)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      ($setup.result.list.length !== 0)
                        ? (_openBlock(), _createElementBlock("ul", {
                            key: 0,
                            class: _normalizeClass($setup.state.layer === 0 ? 'gal_list' : 'gal_list_v2')
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.result.list, (item, idx) => {
                              return (_openBlock(), _createElementBlock("li", {
                                class: _normalizeClass(item.monitoringState === 4 ? 'off' : '')
                              }, [
                                _createElementVNode("div", {
                                  class: _normalizeClass($setup.state.layer === 0 ? 'gal_list_con' : 'gal_con')
                                }, [
                                  ($setup.state.layer === 0)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createElementVNode("div", null, [
                                          _createElementVNode("label", _hoisted_43, [
                                            _withDirectives(_createElementVNode("input", {
                                              type: "checkbox",
                                              name: "",
                                              id: "",
                                              "onUpdate:modelValue": ($event: any) => (($setup.state.checkList[idx]) = $event)
                                            }, null, 8, _hoisted_44), [
                                              [_vModelCheckbox, $setup.state.checkList[idx]]
                                            ]),
                                            _hoisted_45
                                          ]),
                                          (item.isMonitoring === 1 && item.hasMonitoring === 0)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_46, _hoisted_48))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", {
                                          class: "gal_thumb",
                                          onClick: ($event: any) => ($setup.isDetailModal(item.idx))
                                        }, [
                                          _createElementVNode("div", _hoisted_50, [
                                            _createElementVNode("img", {
                                              class: _normalizeClass({ blur: item.imgPath }),
                                              src: item.imgPath ? item.imgPath : require('@/assets/common/NoImg.png'),
                                              onError: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => ($setup.imgError && $setup.imgError(...args)))
                                            }, null, 42, _hoisted_51)
                                          ]),
                                          _createElementVNode("span", _hoisted_52, [
                                            (item.sns === 1)
                                              ? (_openBlock(), _createElementBlock("img", _hoisted_53))
                                              : _createCommentVNode("", true),
                                            (item.sns === 2)
                                              ? (_openBlock(), _createElementBlock("img", _hoisted_54))
                                              : _createCommentVNode("", true),
                                            (item.sns === 3)
                                              ? (_openBlock(), _createElementBlock("img", _hoisted_55))
                                              : _createCommentVNode("", true),
                                            (item.sns === 4)
                                              ? (_openBlock(), _createElementBlock("img", _hoisted_56))
                                              : _createCommentVNode("", true),
                                            (item.sns === 5)
                                              ? (_openBlock(), _createElementBlock("img", _hoisted_57))
                                              : _createCommentVNode("", true),
                                            (item.sns === 6)
                                              ? (_openBlock(), _createElementBlock("img", _hoisted_58))
                                              : _createCommentVNode("", true)
                                          ])
                                        ], 8, _hoisted_49),
                                        _createElementVNode("div", _hoisted_59, [
                                          _createElementVNode("ul", _hoisted_60, [
                                            _createElementVNode("li", _hoisted_61, [
                                              _createElementVNode("div", _hoisted_62, [
                                                _hoisted_63,
                                                _createElementVNode("span", null, _toDisplayString($setup.state.currentPage === 1
                                                                                ? idx + 1
                                                                                : $setup.state.perPage * ($setup.state.currentPage - 1) + idx + 1), 1)
                                              ]),
                                              _createElementVNode("div", _hoisted_64, [
                                                _hoisted_65,
                                                _createElementVNode("span", null, _toDisplayString(item.searchType === 1
                                                                                ? "키워드"
                                                                                : item.searchType === 2
                                                                                  ? "이미지"
                                                                                  : item.searchType === 3
                                                                                    ? "키워드 + 이미지"
                                                                                    : "잘못된 값"), 1)
                                              ])
                                            ]),
                                            _createElementVNode("li", null, [
                                              _hoisted_66,
                                              _createElementVNode("div", _hoisted_67, _toDisplayString(item.idx), 1)
                                            ]),
                                            _createElementVNode("li", null, [
                                              _hoisted_68,
                                              _createElementVNode("div", _hoisted_69, _toDisplayString(item.strNation), 1)
                                            ]),
                                            _createElementVNode("li", null, [
                                              _hoisted_70,
                                              _createElementVNode("div", {
                                                class: "gal_info_con",
                                                innerHTML: item.title
                                              }, null, 8, _hoisted_71)
                                            ]),
                                            _createElementVNode("li", null, [
                                              _hoisted_72,
                                              _createElementVNode("div", {
                                                class: "gal_info_con",
                                                innerHTML: item.hashtag
                                              }, null, 8, _hoisted_73)
                                            ]),
                                            _createElementVNode("li", null, [
                                              _hoisted_74,
                                              _createElementVNode("div", _hoisted_75, [
                                                _createElementVNode("a", {
                                                  href: item.siteUrl,
                                                  target: "_blank"
                                                }, _toDisplayString(item.siteUrl), 9, _hoisted_76)
                                              ])
                                            ]),
                                            _createElementVNode("li", null, [
                                              _hoisted_77,
                                              _createElementVNode("div", _hoisted_78, _toDisplayString($setup.formatDate(item.createDate)), 1)
                                            ])
                                          ]),
                                          _createElementVNode("ul", _hoisted_79, [
                                            _createElementVNode("li", null, [
                                              _hoisted_80,
                                              _createElementVNode("div", _hoisted_81, _toDisplayString(item.author), 1)
                                            ]),
                                            _createElementVNode("li", null, [
                                              _hoisted_82,
                                              _createElementVNode("div", _hoisted_83, [
                                                _createElementVNode("div", _hoisted_84, [
                                                  _createElementVNode("p", null, _toDisplayString(item.messengerId), 1)
                                                ])
                                              ])
                                            ]),
                                            _createElementVNode("li", null, [
                                              _hoisted_85,
                                              _createElementVNode("div", _hoisted_86, _toDisplayString(item.phoneNum), 1)
                                            ]),
                                            _createElementVNode("li", null, [
                                              _hoisted_87,
                                              _createElementVNode("div", _hoisted_88, _toDisplayString(item.reasonContent), 1)
                                            ]),
                                            _createElementVNode("li", null, [
                                              _hoisted_89,
                                              _withDirectives(_createElementVNode("select", {
                                                class: "select",
                                                "onUpdate:modelValue": ($event: any) => ((item.type) = $event),
                                                onChange: ($event: any) => (item.detailType = $setup.getDetailTypeFilter(item.type)[0].idx)
                                              }, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.typeList, (type) => {
                                                  return (_openBlock(), _createElementBlock("option", {
                                                    value: type.idx
                                                  }, _toDisplayString(type.name), 9, _hoisted_91))
                                                }), 256))
                                              ], 40, _hoisted_90), [
                                                [
                                                  _vModelSelect,
                                                  item.type,
                                                  void 0,
                                                  { number: true }
                                                ]
                                              ])
                                            ]),
                                            _createElementVNode("li", null, [
                                              _hoisted_92,
                                              _createElementVNode("div", _hoisted_93, [
                                                _withDirectives(_createElementVNode("select", {
                                                  class: "select",
                                                  "onUpdate:modelValue": ($event: any) => ((item.detailType) = $event),
                                                  onChange: ($event: any) => ($setup.changeDetailType(item))
                                                }, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.getDetailTypeFilter(item.type), (dType) => {
                                                    return (_openBlock(), _createElementBlock("option", {
                                                      value: dType.idx
                                                    }, _toDisplayString(dType.name), 9, _hoisted_95))
                                                  }), 256))
                                                ], 40, _hoisted_94), [
                                                  [
                                                    _vModelSelect,
                                                    item.detailType,
                                                    void 0,
                                                    { number: true }
                                                  ]
                                                ]),
                                                (item.detailType === 6)
                                                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                                      key: 0,
                                                      type: "text",
                                                      "onUpdate:modelValue": ($event: any) => ((item.detail) = $event)
                                                    }, null, 8, _hoisted_96)), [
                                                      [_vModelText, item.detail]
                                                    ])
                                                  : _createCommentVNode("", true),
                                                _createElementVNode("button", {
                                                  type: "button",
                                                  class: "save_btn",
                                                  onClick: ($event: any) => ($setup.saveList(idx))
                                                }, " 저장 ", 8, _hoisted_97)
                                              ])
                                            ])
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_98, [
                                          (item.state !== 0 && item.state !== null)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                (item.similarity)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_99, [
                                                      _createTextVNode(" 유사도 "),
                                                      _createElementVNode("b", null, _toDisplayString(item.similarity), 1),
                                                      _createTextVNode(" % ")
                                                    ]))
                                                  : _createCommentVNode("", true)
                                              ], 64))
                                            : (_openBlock(), _createBlock(_component_Spinner, {
                                                key: 1,
                                                class: "resultProgress"
                                              })),
                                          _createElementVNode("button", {
                                            type: "button",
                                            class: _normalizeClass(["monitoring_btn", item.isMonitoring === 1 && item.hasMonitoring === 1 ? 'on' : '']),
                                            onClick: ($event: any) => ($setup.isMonitoring(idx))
                                          }, null, 10, _hoisted_100)
                                        ])
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  ($setup.state.layer === 1)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createElementVNode("div", _hoisted_101, [
                                          _createElementVNode("div", _hoisted_102, [
                                            _createElementVNode("label", _hoisted_103, [
                                              _withDirectives(_createElementVNode("input", {
                                                type: "checkbox",
                                                "onUpdate:modelValue": ($event: any) => (($setup.state.checkList[idx]) = $event)
                                              }, null, 8, _hoisted_104), [
                                                [_vModelCheckbox, $setup.state.checkList[idx]]
                                              ]),
                                              _hoisted_105
                                            ]),
                                            (item.isMonitoring === 1 && item.hasMonitoring === 0)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_106, _hoisted_108))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _createElementVNode("div", _hoisted_109, [
                                            _createElementVNode("div", _hoisted_110, [
                                              _createElementVNode("img", {
                                                class: _normalizeClass({ blur: item.imgPath }),
                                                src: 
                                                                        item.imgPath ? item.imgPath : require('@/assets/common/NoImg.png')
                                                                    ,
                                                onError: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => ($setup.imgError && $setup.imgError(...args))),
                                                onClick: ($event: any) => ($setup.isDetailModal(item.idx))
                                              }, null, 42, _hoisted_111)
                                            ]),
                                            _createElementVNode("span", _hoisted_112, [
                                              (item.sns === 1)
                                                ? (_openBlock(), _createElementBlock("img", _hoisted_113))
                                                : _createCommentVNode("", true),
                                              (item.sns === 2)
                                                ? (_openBlock(), _createElementBlock("img", _hoisted_114))
                                                : _createCommentVNode("", true),
                                              (item.sns === 3)
                                                ? (_openBlock(), _createElementBlock("img", _hoisted_115))
                                                : _createCommentVNode("", true),
                                              (item.sns === 4)
                                                ? (_openBlock(), _createElementBlock("img", _hoisted_116))
                                                : _createCommentVNode("", true),
                                              (item.sns === 5)
                                                ? (_openBlock(), _createElementBlock("img", _hoisted_117))
                                                : _createCommentVNode("", true),
                                              (item.sns === 6)
                                                ? (_openBlock(), _createElementBlock("img", _hoisted_118))
                                                : _createCommentVNode("", true)
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_119, [
                                            _createElementVNode("button", {
                                              type: "button",
                                              class: _normalizeClass(["monitoring_btn", item.isMonitoring === 1 && item.hasMonitoring === 1 ? 'on' : '']),
                                              onClick: ($event: any) => ($setup.isMonitoring(idx))
                                            }, null, 10, _hoisted_120),
                                            _createElementVNode("div", null, [
                                              _createElementVNode("div", _hoisted_121, [
                                                _createElementVNode("p", _hoisted_122, [
                                                  _hoisted_123,
                                                  _createElementVNode("span", null, _toDisplayString($setup.state.currentPage === 1
                                                                                    ? idx + 1
                                                                                    : $setup.state.perPage * ($setup.state.currentPage - 1) + idx + 1), 1)
                                                ]),
                                                _createElementVNode("p", _hoisted_124, [
                                                  _hoisted_125,
                                                  _createElementVNode("span", null, _toDisplayString(item.strNation), 1)
                                                ])
                                              ]),
                                              (item.similarity)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_126, [
                                                    _createElementVNode("span", null, [
                                                      _createTextVNode(" 유사도 "),
                                                      _createElementVNode("b", null, _toDisplayString(item.similarity), 1),
                                                      _createTextVNode(" % ")
                                                    ])
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ])
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_127, [
                                          _createElementVNode("ul", _hoisted_128, [
                                            _createElementVNode("li", null, [
                                              _hoisted_129,
                                              _createElementVNode("div", _hoisted_130, _toDisplayString(item.idx), 1)
                                            ]),
                                            _createElementVNode("li", null, [
                                              _hoisted_131,
                                              _createElementVNode("div", {
                                                class: "gal_info_con",
                                                innerHTML: item.title
                                              }, null, 8, _hoisted_132)
                                            ]),
                                            _createElementVNode("li", null, [
                                              _hoisted_133,
                                              _createElementVNode("div", {
                                                class: "gal_info_con",
                                                innerHTML: item.hashtag
                                              }, null, 8, _hoisted_134)
                                            ]),
                                            _createElementVNode("li", null, [
                                              _hoisted_135,
                                              _createElementVNode("div", _hoisted_136, [
                                                _createElementVNode("a", {
                                                  href: item.siteUrl,
                                                  target: "_blank"
                                                }, _toDisplayString(item.siteUrl), 9, _hoisted_137)
                                              ])
                                            ]),
                                            _createElementVNode("li", null, [
                                              _hoisted_138,
                                              _createElementVNode("div", _hoisted_139, _toDisplayString($setup.formatDate(item.createDate)), 1)
                                            ]),
                                            _createElementVNode("li", null, [
                                              _hoisted_140,
                                              _createElementVNode("div", _hoisted_141, _toDisplayString(item.author), 1)
                                            ]),
                                            _createElementVNode("li", null, [
                                              _hoisted_142,
                                              _createElementVNode("div", _hoisted_143, [
                                                _createElementVNode("div", _hoisted_144, [
                                                  _createElementVNode("p", null, _toDisplayString(item.messengerId), 1)
                                                ])
                                              ])
                                            ]),
                                            _createElementVNode("li", null, [
                                              _hoisted_145,
                                              _createElementVNode("div", _hoisted_146, _toDisplayString(item.phoneNum), 1)
                                            ]),
                                            _createElementVNode("li", null, [
                                              _hoisted_147,
                                              _createElementVNode("div", _hoisted_148, _toDisplayString(item.reasonContent), 1)
                                            ]),
                                            _createElementVNode("li", null, [
                                              _hoisted_149,
                                              _withDirectives(_createElementVNode("select", {
                                                class: "select",
                                                "onUpdate:modelValue": ($event: any) => ((item.type) = $event),
                                                onChange: ($event: any) => (item.detailType = $setup.getDetailTypeFilter(item.type)[0].idx)
                                              }, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.typeList, (type) => {
                                                  return (_openBlock(), _createElementBlock("option", {
                                                    value: type.idx
                                                  }, _toDisplayString(type.name), 9, _hoisted_151))
                                                }), 256))
                                              ], 40, _hoisted_150), [
                                                [
                                                  _vModelSelect,
                                                  item.type,
                                                  void 0,
                                                  { number: true }
                                                ]
                                              ])
                                            ]),
                                            _createElementVNode("li", null, [
                                              _hoisted_152,
                                              _createElementVNode("div", _hoisted_153, [
                                                _withDirectives(_createElementVNode("select", {
                                                  name: "",
                                                  id: "",
                                                  class: "select",
                                                  "onUpdate:modelValue": ($event: any) => ((item.detailType) = $event),
                                                  onChange: ($event: any) => ($setup.changeDetailType(item))
                                                }, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.getDetailTypeFilter(item.type), (dType) => {
                                                    return (_openBlock(), _createElementBlock("option", {
                                                      value: dType.idx
                                                    }, _toDisplayString(dType.name), 9, _hoisted_155))
                                                  }), 256))
                                                ], 40, _hoisted_154), [
                                                  [
                                                    _vModelSelect,
                                                    item.detailType,
                                                    void 0,
                                                    { number: true }
                                                  ]
                                                ]),
                                                (item.detailType === 6)
                                                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                                      key: 0,
                                                      type: "text",
                                                      name: "",
                                                      id: "",
                                                      "onUpdate:modelValue": ($event: any) => ((item.detail) = $event)
                                                    }, null, 8, _hoisted_156)), [
                                                      [_vModelText, item.detail]
                                                    ])
                                                  : _createCommentVNode("", true),
                                                _createElementVNode("button", {
                                                  type: "button",
                                                  class: "save_btn",
                                                  onClick: ($event: any) => ($setup.saveList(idx))
                                                }, " 저장 ", 8, _hoisted_157)
                                              ])
                                            ])
                                          ])
                                        ])
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ], 2)
                              ], 2))
                            }), 256))
                          ], 2))
                        : (_openBlock(), _createBlock(_component_NoResult, {
                            key: 1,
                            class: "result_load"
                          })),
                      ($setup.result.list.length !== 0 && !$setup.state.isLoading)
                        ? (_openBlock(), _createBlock(_component_PageBtn, {
                            key: 2,
                            currentPage: $setup.state.currentPage,
                            totalLength: $setup.state.totalLength,
                            perPage: $setup.state.perPage,
                            onOnPaging: $setup.handlePageChange
                          }, null, 8, ["currentPage", "totalLength", "perPage", "onOnPaging"]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : (_openBlock(), _createBlock(_component_Spinner, {
                      key: 1,
                      isLoading: $setup.state.isLoading,
                      class: "result_load"
                    }, null, 8, ["isLoading"]))
              ], 2)
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Popup, {
      show: $setup.state.isModalOpen,
      title: $setup.modal.title,
      content: $setup.modal.content,
      onClose: $setup.modalClose
    }, null, 8, ["show", "title", "content", "onClose"])
  ], 64))
}